export const viewNoteHistory = (note) => {
    console.log('View note history, TODO:', note);
};
//# sourceMappingURL=history.js.map